export default function defined(val) {
  return (val !== undefined) && (val !== null);
}



// WEBPACK FOOTER //
// ./src/core/defined.js